import { NutrientsFieldEnum as Fields } from 'Common/FieldEnum';

export const DRVFields = [
  Fields.Water,
  Fields.Ash,
  Fields.Iron,
  Fields.Calcium,
  Fields.VitaminAIU,
  Fields.VitaminC,
  Fields.VitaminD,
  Fields.Potassium,
];
export const DRVConversions = {
  [Fields.Iron]: 18,
  [Fields.Calcium]: 1000,
  [Fields.VitaminAIU]: 5000,
  [Fields.VitaminC]: 60,
  [Fields.VitaminD]: 20,
  [Fields.Potassium]: 4700,
};



// WEBPACK FOOTER //
// ./src/common/Constants/nutrients.js